import React      from 'react';
import PropTypes  from 'prop-types';
import classNames from 'classnames';

const SelectAllSection = props => (
  <div className="select-all">
    <h3>{props.title}</h3>
    <button
      aria-label={props.label}
      aria-checked={props.selectedAll}
      className={classNames('btn btn-link', {selected: props.selectedAll})}
      disabled={!props.enabled}
      role="checkbox"
      onClick={props.selectedAll ? props.selectNone : props.selectAll}
    >
      Select all&nbsp;
      <i className={classNames('checkbox', props.selectedAll ? 'fas fa-check-square' : 'far fa-square')} />
    </button>
  </div>
);

SelectAllSection.propTypes = {
  enabled: PropTypes.bool,
  label: PropTypes.string,
  selectAll: PropTypes.func.isRequired,
  selectedAll: PropTypes.bool.isRequired,
  selectNone: PropTypes.func.isRequired,
  title: PropTypes.string,
};

export default SelectAllSection;
